import useLocalStorage from "@rehooks/local-storage";
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { murmurhash3_32_gc } from "utils/string.util";

export function useTrackedArticles(url) {
  const [trackedUrlHash, setTrackedHash] = useState(murmurhash3_32_gc(String(url)));
  const { user } = useSelector((state) => state.auth);


  const [clickedLinks, setClickedLinks] = useLocalStorage(
    `sooth-opened-links-${user.userId}`,
    [murmurhash3_32_gc(String(null))]
  );

  const hasBeenClicked = useMemo(
    () => clickedLinks.includes(trackedUrlHash),
    [clickedLinks, trackedUrlHash]
  );

  return {
    addClickedLink: (link) => {
      setClickedLinks([murmurhash3_32_gc(String(link)), ...clickedLinks]);
    },
    hasBeenClicked,
    updateTrackedLink: (link) => {
        setTrackedHash(murmurhash3_32_gc(String(link)));
    }
  };
}
